import type{UiContractOffer}from'./bridge';
import type{Requirement}from'../sim/systems/goals';
export function contractTermText(r:Requirement):string{
 if('all'in r)return r.all.map(contractTermText).join('; ');
 if('any'in r)return `Any one: ${r.any.map(contractTermText).join(' or ')}`;
 if('not'in r)return `Must not: ${contractTermText(r.not)}`;
 if('species'in r&&!('op'in r))return `Species: ${r.species.replace(/_/g,' ')}`;
 if('pair'in r)return r.pair?'Male and female required':'No pair requirement';
 if('min_quality'in r)return `Contract quality at least ${r.min_quality} (current contract rule uses health)`;
 if('max_inbreeding'in r)return `Inbreeding F at most ${r.max_inbreeding}`;
 return 'Unsupported delivery condition: command will refuse';
}
export function contractSelectionGap(o:UiContractOffer,ids:string[]):string|null{
 if(ids.length!==o.count||new Set(ids).size!==ids.length)return `Choose exactly ${o.count} different animals`;
 const rows=ids.map(id=>o.deliveryRoster?.find(a=>a.animalId===id));
 if(rows.some(a=>!a))return 'Animal eligibility unavailable. Refresh before delivering.';
 const roster=rows.filter((a):a is NonNullable<typeof a>=>a!==undefined);
 const blocked=roster.find(a=>a.blockedReason);if(blocked)return blocked.blockedReason;
 const check=(r:Requirement):string|null=>{
  if('all'in r){for(const sub of r.all){const gap=check(sub);if(gap)return gap;}return null;}
  if('any'in r)return r.any.some(sub=>check(sub)===null)?null:'No requirement alternative met';
  if('not'in r)return check(r.not)===null?'Negated condition holds':null;
  if('species'in r&&!('op'in r))return o.species===r.species?null:'Species requirement unmet';
  if('pair'in r)return !r.pair||roster.some(a=>a.sex==='M')&&roster.some(a=>a.sex==='F')?null:'Choose both a male and a female';
  if('min_quality'in r)return roster.every(a=>a.health>=r.min_quality)?null:'Contract quality bar unmet (current rule uses health)';
  if('max_inbreeding'in r)return roster.every(a=>a.inbreedingBp<=Math.floor(r.max_inbreeding*10000))?null:'Inbreeding exceeds contract limit';
  return 'Unsupported delivery condition';
 };
 return o.requires?check(o.requires):null;
}
